import axios from "axios";

const setAuthToken = (token: string | null): void => {
    if (token) {
        // Set the Authorization header with Bearer token
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        // Set the platform header
        axios.defaults.headers.common["platform"] = 'web';
    } else {
        // If no token, remove the Authorization header
        delete axios.defaults.headers.common["Authorization"];
    }
};

export default setAuthToken;
